module.exports = __webpack_public_path__ + "img/pic-tz.630926ef.png";